import { createFileRoute } from '@tanstack/react-router';

import { AllLocations } from 'features/locations/AllLocations';

export const Route = createFileRoute('/_authenticated/locations/_shell/')({
  component: AllLocations
});
